import React from "react";

const KebijakanPrivasiEN: React.FC = () => (
  <>
    <p>
      PT IQ Edukasi and its affiliate(s) (&ldquo;<strong>CoLearn</strong>
      &rdquo;, &ldquo;<strong>we</strong>&rdquo;, &ldquo;<strong>our</strong>
      &rdquo;, or &ldquo;<strong>us</strong>&rdquo;) realise the importance of
      protection to the privacy of every party who access and/or use (&ldquo;
      <strong>User</strong>&rdquo;) our mobile application
      &lsquo;CoLearn&rsquo;, website (www.colearn.id), feature, technology,
      content and digital product that we provide through said CoLearn mobile
      application and/or website (namely, www.colearn.id), as the case may be
      (&ldquo;<strong>Platform</strong>&rdquo;). We are committed to protecting
      and respecting the privacy of User.
    </p>
    <p>
      Through this Privacy Policy (&ldquo;<strong>Policy</strong>&rdquo;), we
      will explain to the User how we use the personal data that we obtain by
      providing our service to the User and/or that the User provide to us
      (&ldquo;<strong>Personal Data</strong>&rdquo;) during accessing and/or
      using the Platform. This Policy is applicable for all Users of the
      Platform, unless stated differently. We encourage the User to read this
      Policy before accessing and/or using the Platform.
    </p>
    <p>
      By accessing and/or using the Platform, the User and/or the parents or
      guardian of the User (in the event that the User is under 18 (eighteen)
      years old) represent, warrants and acknowledge that the User and/or the
      parents or guardian of the User, have read carefully and understand all
      contents and consequences of this Policy.
      <strong>
        IF THE USER IS NOT AGREED WITH ANY TERMS AND CONDITIONS CONTAINED IN
        THIS POLICY, PLEASE DO NOT PROCEED TO ACCESS, AND/OR USE THE PLATFORM
      </strong>
      .
    </p>
    <p>This Policy is explaining the following matters:</p>
    <ol type="A">
      <li>
        <strong>Personal Data Collection</strong>
        <br />
        We may collect Personal Data of the User with the following methods:
        <div>
          <ol type="1">
            <li>
              <strong>Personal Data that the User provide to us</strong>
              <br />
              The User may provide the Personal Data through the electronic form
              in our Platform or by corresponding through phone, email, and
              others. This Personal Data includes the information provided by
              the User while registering on our Platform, subscribing or
              accessing our services, searching for a product, participating in
              an online discussion or other social media feature on our
              Platform, joining the competition, promotion or survey as well as
              when the User reports any problem with our Platform or another
              medium. The Personal Data that is provided by the User (including
              your child while accessing or using our services) may include
              name, date of birth, gender, address, email address, phone number,
              grade/class of the student, school name, limited payment
              information (credit/debit card details) if required, survey
              feedback, personal description, photo, video and other necessary
              data to provide or improve services or other purposes as indicated
              herein. We may request the User to verify the information that has
              been given to us to ensure the accuracy of such information.
            </li>
            <li>
              <strong>Personal Data that we collect</strong>
              <br />
              Every time the User accesses and/or uses our Platform, we may
              automatically collect the following data and information:
              <ol type="i">
                <li>
                  Technical information, which includes the IP address used to
                  connect the User&rsquo;s computer to the internet, log-in
                  information of the User, type and version of the browser used,
                  time zone setting, type and version of the browser plug-in,
                  device metadata, device information, and operating system;
                </li>
                <li>
                  Information on the User&rsquo;s visit, which includes a
                  complete list of uniform resource locator (URL) which leads to
                  or visited through and from our Platform (including date and
                  time of visit); the product that you look for or search for;
                  page response time, download issues, duration of visit to
                  certain pages, information on the interaction on the page
                  (e.g., scrolls, click, and mouse movements), methods used to
                  leave the Platform, and the phone number used to contact our
                  customer service; and
                </li>
                <li>
                  Test score of the User, including but not limited to the
                  analytics/test results of the User from the Platform.
                </li>
              </ol>
            </li>
            <li>
              <strong>Personal Data that we gather from other sources</strong>
              <br />
              We may obtain the Personal Data should the User use other sites
              that we operate or other services that we provide. We also
              collaborate with the third party (including, but not limited to,
              the business partner, the sub-contractor on the technical
              services, payment and delivery services, advertising network,
              website analytical service providers, and search engine providers)
              (&ldquo;<strong>Our Partners</strong>&rdquo;) and may share or
              obtain the information from them which may not be fully correct.
            </li>
          </ol>
        </div>
      </li>
      <li>
        <strong>Use of the Personal Data</strong>
        <br />
        We may use the Personal Data of the User for the following matters:
        <div>
          <ol type="1">
            <li>
              Personal Data that the User provides to us may be used for the
              following purposes:
              <br />
              <ol type="i">
                <li>
                  Conducting our obligations in providing the User with the
                  information, products, and services;
                </li>
                <li>
                  Providing information related to the products and other
                  services that we offer; to provide to the User or authorizing
                  the third party to provide to the User information on the
                  products and services that we think may interest the User. We
                  or Our Partners may electronically or otherwise contact the
                  User to provide information on our products and services;
                </li>
                <li>
                  Informing the User regarding the change in our services;
                </li>
                <li>
                  Ensuring that the contents of our Platform are presented in
                  the most effective ways for the User; and
                </li>
                <li>
                  We may share User data with Our affiliates, such entities may
                  be outside Indonesia. The information may be reasonably
                  required to be shared with a third party in case of
                  restructuring of our company or its business assets, wherein
                  such business assets may necessarily include transferring
                  records and access to your data available with us.
                </li>
              </ol>
            </li>
            <li>
              Personal Data that we collect may also be used for the following
              purposes:
              <br />
              <ol type="i">
                <li>
                  Managing the Platform and our internal operation, including
                  troubleshooting, data analysis, testing, research, as well as
                  other statistical and survey purposes by us or Our Partners;
                </li>
                <li>
                  Improving our Platform so that the contents are ensured to be
                  presented in the most effective way for the User;
                </li>
                <li>
                  Enabling the User to participate in the interactive features
                  of our services, exchanges, or delivery of information to
                  create a comprehensive understanding in relation to the
                  product, service, verification, complaint, etc;
                </li>
                <li>
                  As part of our effort to ensure and improve the safety and
                  security of our Platform;
                </li>
                <li>to personalize the User’s experience;</li>
                <li>
                  to process the User’s payment transaction on the Platform and
                  support settlement of payment activities in the Platform or by
                  a third party as appointed by us or the User; and/or
                </li>
                <li>
                  Providing input and recommendations to the User on the
                  Platform concerning the product and services that may attract
                  the interest of the User.
                </li>
              </ol>
            </li>
            <li>
              Personal Data that we gather from other sources may be used for
              the following purposes: We may combine the information we gather
              from other sources with the information provided by the User and
              the information we may collect from your usage or access to the
              Platform. We may use this information or the combined information
              for the above purposes.
            </li>
          </ol>
        </div>
      </li>
      <li>
        <strong>Disclosure of the Personal Data</strong>
        <br />
        We own the database rights in the collected Personal Data. In providing
        our services and operating our business, we may allow our affiliate or
        Our Partners to access the Personal Data for limited purposes.
        <br />
        In addition, we may disclose the Personal Data with the third parties
        where:
        <div>
          <ol type="a">
            <li>
              The User has provided written consent to us for disclosing the
              Personal Data in this way:
            </li>
            <li>
              We sell or purchase the company and/or our company&rsquo;s assets,
              we may disclose the data to the prospective purchaser or seller of
              such company or company&rsquo;s assets;
            </li>
            <li>
              We or our affiliate(s) or its substantial assets are acquired by
              the third party, then the Personal Data of our User shall be one
              of the assets to be transferred;
            </li>
            <li>
              We are under the responsibility to disclose or share the data to
              comply with the obligation of applicable law and other agreements;
              or to protect the rights, assets, or security of us, the User, and
              others. This also includes the exchange of information with the
              company and other organizations for the purposes of protection
              from fraud and credit risk reduction;
            </li>
            <li>
              We provide anonymous statistical information regarding the user of
              the Platform and related usage information to the third parties,
              including analytics and search engine providers;
            </li>
            <li>
              We may, also share some Personal Data of User to certain third
              parties, such as email, IP address, or information about the
              browser, device identification number, or operating system you
              used or analytical data arising therefrom with the third party
              such as advertisers, advertising agencies, and/or advertising
              intermediaries relevant information needed to select and offer
              suitable advertisements to you and other users which could be a
              third party product advertisement on an as-is basis, including
              information contained in cookies or other online identifiers (if
              it contains Personal Data). In case of any third party
              advertisement, we do not solicit usage, approve quality or
              recommend the use of any third party product or services
              advertised; or
            </li>
            <li>
              We use a third-party service provider to provide services that
              involve data processing, for example, archival, auditing,
              reference checking, professional advisory (including legal,
              accounting, financial, and business consulting), mailing house,
              delivery, technology, website, research, banking, payment, client
              contact, data processing, insurance, forensic litigation support,
              marketing, advertising, and security services.
            </li>
          </ol>
        </div>
        <p>
          Some of the third parties with whom we share Personal Data may be
          located outside Indonesia. While such third parties are subject to the
          privacy and confidentiality obligation, in the event such obligation
          is subject to a certain law, the User acknowledges that such
          obligation may be different and be less stringent than the prevailing
          laws and regulations in Indonesia. In those cases, we are not
          responsible for imposing the Indonesian laws and regulations, and the
          User may not be able to seek redress under those laws.
        </p>
      </li>
      <li>
        <strong>Storage of Personal Data</strong>
        <br />
        All Personal Data provided by the User to us is stored in the secured
        electronic media storage. By delivering the Personal Data to the
        Platform, the User approves the transfer, storage, and processing that
        occurs on our Platform. We will take reasonable steps to ensure that the
        Personal Data is treated securely and pursuant to the Policy as well as
        the prevailing laws and regulations.
        <p>
          To the extent not prohibited under the applicable laws, we may store
          all Personal Data that Users provides: (i) as long as the User is
          still a user of our Platform and (ii) at least 5 (five) years from the
          date on which the User is no longer using our Platform (i.e. user
          Deleting the Account); or (iii) in accordance with the original
          purpose of collecting the Personal Data including for compliance with
          applicable laws and the needs of the business or records purposes.
          Further, we may extend or reduce the Data storage/retention period for
          some types of data if needed by Us: (i) in the interest of the law or
          the needs of the business and record keeping; (ii)to free up storage
          space, as the case may be.
        </p>
        <p>
          The obligation to maintain the confidentiality of Personal Data will
          not or no longer apply to Personal Data that:
        </p>
        <div>
          <ol type="1">
            <li>
              has been made known to the public at the time of disclosure or has
              been known to the public afterward by means other than through our
              actions or negligence;
            </li>
            <li>has been known by us before Personal Data is disclosed;</li>
            <li>
              we obtain appropriately from third parties without any obligation
              to maintain the confidentiality of Personal Data;
            </li>
            <li>the disclosure has been permitted by the User; and/or</li>
            <li>
              must be disclosed based on the provisions of the applicable laws
              and regulations, court rulings, or other governmental authorities
              in any country.
            </li>
          </ol>
          <p>
            The User agrees that we will not be responsible for any security
            breaches related to messages, information, or documents sent by the
            User through the internet.
          </p>
          <p>
            In the event of a failure to protect Personal Data on the Platform,
            we will notify the User in writing, whether through electronic or
            other media, and will endeavor to take commercially reasonable
            action to secure the same.
          </p>
        </div>
      </li>
      <li>
        <strong>Rights of the User</strong>
        <br />
        The Users may request the removal of the User&rsquo;s Personal Data on
        the Platform or withdraw the User&rsquo;s approval for any or all
        collection, use or disclosure of the User&rsquo;s Personal Data by
        giving us reasonable notice in writing through the contact details
        stated in this Policy. Depending on the circumstances and nature of the
        request that the User requests, the User must understand and acknowledge
        that after withdrawing the approval or request for deletion, the User
        may no longer be able to use the Platform. Withdrawing the User&rsquo;s
        approval may result in the termination of the User&rsquo;s account or
        the contractual relationship of the User with us, with all rights and
        obligations that arise fully must be fulfilled. After receiving
        notification to withdraw approval for the collection, use, or disclosure
        of the User&rsquo;s Personal Data, we will inform the User of the
        possible consequences of such a withdrawal so that the User can decide
        whether the User still wants to withdraw the approval or not.
        <p>
          The Users can ask us to access and/or correct the Personal Data of the
          Users, which are in our possession and control, by contacting us in
          the details provided in this Policy.
        </p>
        <p>
          Our Platform and contents may, from time to time, contain links to and
          from sites belonging to partner networks, third party advertisers, and
          other affiliates. If the user follows a link to one of these sites,
          please note that these sites have their own privacy policy and that we
          are not responsible or have any liability for those policies. Please
          check these policies before the User submits any information to these
          sites.
        </p>
      </li>
      <li>
        <strong>Cookies Policy</strong>
        <br />
        When the User uses the Platform, we may place a number of cookies in
        your browser. Cookies are small digital files containing letters and
        numbers that we store on your computer&rsquo;s browser or hard drive
        with your consent. Cookies contain information that is transferred to
        your computer&rsquo;s hard disk.
        <p>
          Cookies can be used for the following purposes: (i) activate certain
          functions; (ii) provide analysis; (iii) save your preferences; and
          (iv) allow the delivery of advertising and advertising based on
          behavior. Some of these cookies will only be used if you use certain
          features, or choose certain preferences, while some other Cookies will
          always be used.
        </p>
      </li>
      <li>
        <strong>Acknowledgment and Approval</strong>
        <br />
        By agreeing to the Policy by registration, access or usage of Platform
        or other services, viewing contents, the User and/or the parents or
        guardians of the User (in the case that the User is under 18 (eighteen)
        years) acknowledge that the User has read and understood this Policy and
        agree to all its terms. Accordingly, the User agrees and gives us
        consent to collect, use, share, disclose, store, transfer, or process
        your Personal Information in accordance with this Policy and Terms of
        Conditions.
      </li>
      <li>
        <strong>Data Ownership</strong>
        <br />
        Subject to the provision of this Policy, no title, license, copyright,
        or any other rights, regardless of whether or not covered by
        intellectual and/or industrial property rights, are granted expressly or
        impliedly. All data relating to the User’s personal data that the User
        posts, submits, transmits, uploads, or otherwise makes available during
        the utilization of the Platform would still belong to the User.
      </li>
      <li>
        <strong>Marketing Material</strong>
        <br />
        We and Our Partners can send the User and/or the parents or guardians of
        the User direct marketing, advertising, and promotional communications
        through the push-notification application, messaging through the
        application, post, telephone call, short message service, email and/or
        other messaging application (&ldquo;<strong>Marketing Material</strong>
        &rdquo;) if the User has agreed to subscribe to our mailing list, and/or
        agree to receive marketing and promotional material from us. The User
        can choose not to receive marketing communications at any time by
        contacting us through the contact details listed in this Policy. Please
        note that if the User chooses to leave, we may still send the User
        non-promotional messages, such as receipts or information about the
        account of the User. In case of third party products or services
        advertised in our Platform and/or in Colearn contents, we hereby clarify
        that we neither confirm/verify the quality of such third party
        products/services nor solicit and promote usage of such third party
        products/services (if any), and we shall not be responsible for your
        decision to rely on such ads in whatever form and manner.
      </li>
      <li>
        <strong>Changes to the Privacy Policy</strong>
        <br />
        Any changes that we make to our Policy in the future will be published
        through this page and, when needed, notified to the User by electronic
        mail. Please revisit this page from time to time to see any updates or
        changes to our Policy.
      </li>

      <li>
        <strong>Contact</strong>
        <br />
        If the User has questions regarding this Policy or if the User wants to
        get access and/or make corrections to the Personal Data of the User,
        please contact us via{" "}
        <a href="mailto:info@colearn.id">info@colearn.id</a>.
      </li>
      <li>
        <strong>
          Language
          <br />
        </strong>
        This Policy is made in the Indonesian language and English language. In
        the event of any inconsistency or different interpretation between the
        Indonesian language version and the English language version, the User
        agrees that the Indonesian language version will prevail to the extent
        of such inconsistency or conflict, and the relevant English language
        version is deemed to be automatically amended to be consistent with the
        relevant part of the Indonesian language version.
      </li>
    </ol>
    <p>
      Updated on: <strong>30 November 2022</strong>.
    </p>
  </>
);

export default KebijakanPrivasiEN;
